/**
 * Verifica se o canal de venda a entrega é realizada pela Packk
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const checkDeliveryFromPackk = (canalDeVenda) => {
  const allowedSaleChannels = ['americanas', 'vtex', 'magalu'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}